<template>
    <form style="position: relative">
      <div style="position:absolute; top: 10px; right: 10px;">
      <CopyBlock :sharedData="sharedData" />
      </div>
      <h2>{{ $t('Add.Spacer.Spacer') }} Block</h2>
      <div class="accordion-item">
      <div class="accordion-header">
        <span>{{ $t('Add.General.Main') }}</span>
      </div>
      <div class="accordion-content">
      <div class="divider">
        <div class="range-container">
          <label for="height">
            <span class="material-symbols-outlined">height</span>
          </label>
          <input
            type="range"
            min="1"
            max="100"
            v-model="height"
            class="slider"
            id="paddingBottom"
          />
          <span>{{ height}} px</span>
        </div>
      </div>
      <NameProp :sharedData="sharedData" />
      <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
    </form>
  </template>
  
  <script>
  import { isNameUnique } from '@/utils/isNameUnique';
  import NameProp from './AddProps/NameProp.vue';
  import ClassNamesProp from './AddProps/ClassNamesProp.vue';
  import CopyBlock from './AddProps/CopyBlock.vue';
  export default {
    name: 'AddSpacer',
    components: {
      NameProp,
      ClassNamesProp,
      CopyBlock,
    },
    props: ['sharedData'],
    computed: {
      height: {
        get() {
          return this.sharedData?.data?.props?.height || 16;
        },
        set(value) {
          if (!this.sharedData.data.props) this.sharedData.data.props = {};
          this.sharedData.data.props.height = value;
        },
      },
      activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
    },
   mounted() {
    this.isUniqueName = isNameUnique(this.sharedData.data.props.name, this.sharedData.id);
   },
   watch: {
    'sharedData.data.props.name': function(newName) {
      this.isUniqueName = isNameUnique(newName, this.sharedData.id); // Name check
      console.log(this.isUniqueName)
    }
  }
  };
  </script>
  
  <style scoped>
  @import '../../styles/addComponents.css';
  </style> 
  